import React from 'react'

const ArrowIcon = () => {
  return (
    <svg viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" className="arrow-icon">
      <title>Arrow</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4091 10.4113L10.5701 1.40909L10.2948 1.6898L18.6683 10.2139L0.812365 10.2139H0.590906V10.4113V10.6083L18.6683 10.6083L10.2948 19.1327L10.5701 19.4091L19.4091 10.4113Z"
        fill="white"
        stroke="white"
      />
    </svg>
  )
}

export default ArrowIcon
